import { render, staticRenderFns } from "./LegalPrivacy.vue?vue&type=template&id=7f358f20&scoped=true&"
import script from "./LegalPrivacy.vue?vue&type=script&lang=js&"
export * from "./LegalPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f358f20",
  null
  
)

export default component.exports